import { Box, styled, TextField } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
  width: '100%',
}));

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  width: '100%',
}));
